import { VerticalBarChartComponent } from '../charts/vertical-bar-chart-component'

export class AFCompareSovByMentionTypeVert extends VerticalBarChartComponent {
 static config = {
  selector: 'afCompareSovByMentionTypeVert',
  controller: AFCompareSovByMentionTypeVert,
  bindings: VerticalBarChartComponent.config.bindings,
  template: VerticalBarChartComponent.config.template,
 }

 setProperties() {
  this.seriesColors = this.colorUtils.compareMetaColors(this.visualizationMetaData)
  // ALPHA-691
  //this.dataLabelFormatter = this.labelUtils.compareVertBarFormatter
 }

 updateData(data) {
  this.visualizationData = this.buildChartData(
   this.namingUtils.returnData(this.sortCompareArray(this.vizData.data, this.visualizationMetaData))
  )
 }

 onPointClick = () => {}
}
